import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { LoadingOverlay } from '@mantine/core';
import colors from '../utils/colors';

const Redirector: React.FC = () => {

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const isLogged = localStorage.getItem('isLogged');
    if (isLogged) {
        navigate('/dashboard');
    } else {
        navigate('/login');
    }
  }, [navigate, location]);

  return (
    <div className="relative flex flex-col min-h-screen bg-gradient-to-r from-customBg via-customBg2 to-customBg/80">
        <LoadingOverlay
            visible
            overlayProps={{ radius: 'lg', blur: 3, opacity: 0.1 }}
            loaderProps={{ color: colors.custom36s, type: 'bars', size: 50 }}
            transitionProps={{ transition: 'fade', duration: 200 }}
        />
    </div>
  );
};

export default Redirector;
